import { AxiosError } from 'axios';
import { GET_ANNOUNCEMENT_CANDIDATE_TYPES_URL } from 'web-library/constants/apiUrls';
import { GET_ANNOUNCEMENT_CANDIDATE_TYPES_QUERY_KEY } from 'web-library/constants/queryKeys';
import axiosClient from '../axiosClient';
import { ConfigurationType } from '../../api/candidate/config/model';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: ConfigurationType[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAnnouncementCandidateTypes = ({ onSuccess, onError }: Input = {}) => {
  const getAnnouncementCandidateTypes = async () => {
    const res = await axiosClient.get<ConfigurationType[]>(GET_ANNOUNCEMENT_CANDIDATE_TYPES_URL);
    return res.data;
  };

  return useCustomQuery(GET_ANNOUNCEMENT_CANDIDATE_TYPES_QUERY_KEY, getAnnouncementCandidateTypes, {
    onSuccess,
    onError,
  });
};
